import * as i0 from '@angular/core';
import { Injectable, NgModule, APP_INITIALIZER, EventEmitter } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpClientModule, HttpHeaders } from '@angular/common/http';

/* tslint:disable */
/**
 * Global configuration for Api services
 */
class LibConfiguration {
    constructor() {
        this.rootUrl = '';
        this.grant_type = '';
        this.client_id = '';
        this.client_secret = '';
        this.default_routes = true;
        this.oauthMode = true;
    }
}
LibConfiguration.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: LibConfiguration, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
LibConfiguration.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: LibConfiguration, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: LibConfiguration, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

/* tslint:disable */
/**
 * Provider for all Api services, plus LibConfiguration
 */
class ApiModule {
    static forRoot(customParams) {
        return {
            ngModule: ApiModule,
            providers: [
                {
                    provide: LibConfiguration,
                    useValue: {
                        rootUrl: customParams.rootUrl,
                        grant_type: customParams.grant_type,
                        client_id: customParams.client_id,
                        client_secret: customParams.client_secret,
                        default_routes: customParams.default_routes,
                        oauthMode: customParams.oauthMode
                    }
                }
            ]
        };
    }
}
ApiModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: ApiModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ApiModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: ApiModule, imports: [HttpClientModule], exports: [HttpClientModule] });
ApiModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: ApiModule, providers: [
        LibConfiguration
    ], imports: [[
            HttpClientModule
        ], HttpClientModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: ApiModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        HttpClientModule
                    ],
                    exports: [
                        HttpClientModule
                    ],
                    declarations: [],
                    providers: [
                        LibConfiguration
                    ],
                }]
        }] });

class ApiProvider {
    constructor(http, config) {
        this.http = http;
        this.config = config;
        this.url = this.config.rootUrl;
    }
    get(endpoint, params, options = {}) {
        if (!options) {
            options = {};
        }
        if (params) {
            options.params = params;
        }
        return this.http.get(this.url + '/' + endpoint, options);
    }
    post(endpoint, body, options) {
        return this.http.post(this.url + '/' + endpoint, body, options);
    }
    form(endpoint, params, options = {}) {
        options.headers = new HttpHeaders().set("Content-Type", 'application/x-www-form-urlencoded');
        let p = new URLSearchParams();
        for (let k in params) {
            p.set(k, params[k]);
        }
        return this.http.post(this.url + '/' + endpoint, p.toString(), options);
    }
    put(endpoint, body, options) {
        return this.http.put(this.url + '/' + endpoint, body, options);
    }
    delete(endpoint, options) {
        return this.http.delete(this.url + '/' + endpoint, options);
    }
    patch(endpoint, body, options, url = this.url) {
        return this.http.put(url + '/' + endpoint, body, options);
    }
    getUrl() {
        return this.url;
    }
    getEndpoint(url, params = null) {
        let opt = null;
        if (params) {
            opt = '?';
            for (let key in params) {
                opt += key + "=" + params[key] + "&";
            }
        }
        return this.getUrl() + '/' + url + (opt === null ? '' : opt);
    }
}
ApiProvider.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: ApiProvider, deps: [{ token: i1.HttpClient }, { token: LibConfiguration }], target: i0.ɵɵFactoryTarget.Injectable });
ApiProvider.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: ApiProvider, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: ApiProvider, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: LibConfiguration }]; } });

class AngularAuthModule {
    static forRoot(rootEnv) {
        function initEnvironment(lib) {
            return () => {
                lib.rootUrl = rootEnv.rootUrl;
                lib.grant_type = rootEnv.grant_type;
                lib.client_id = rootEnv.client_id;
                lib.client_secret = rootEnv.client_secret;
                lib.default_routes = rootEnv.default_routes;
                lib.oauthMode = rootEnv.oauthMode;
            };
        }
        const INIT_ENVIRONMENT = {
            provide: APP_INITIALIZER,
            useFactory: initEnvironment,
            deps: [LibConfiguration],
            multi: true
        };
        return {
            ngModule: ApiModule,
            providers: [
                INIT_ENVIRONMENT
            ]
        };
    }
}
AngularAuthModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: AngularAuthModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AngularAuthModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: AngularAuthModule, imports: [ApiModule] });
AngularAuthModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: AngularAuthModule, providers: [
        ApiProvider
    ], imports: [[
            ApiModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: AngularAuthModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [
                        ApiModule
                    ],
                    providers: [
                        ApiProvider
                    ],
                    exports: []
                }]
        }] });

const USER_EVENT_CHANGE = 'user:change';
const EVENT_KEY_USER = 'user:change';

const STORAGE_KEY_AUTH = "current_auth";
const STORAGE_KEY_LOGIN = "current_login";
const STORAGE_KEY_USER = "current_user";

class BaseCustomService {
    constructor() {
        this.events = new EventEmitter();
    }
    getLocal(key) {
        let result = JSON.parse(localStorage.getItem(key));
        return result;
    }
    setLocal(key, item) {
        localStorage.setItem(key, JSON.stringify(item));
        return this;
    }
    clearLocal() {
        let returned = 0;
        let todelete = [
            STORAGE_KEY_AUTH, STORAGE_KEY_USER
        ];
        for (let item of todelete) {
            this.removeLocal(item);
            returned++;
            if (returned >= todelete.length) {
                return this;
            }
        }
    }
    removeLocal(key) {
        localStorage.removeItem(key);
        return this;
    }
    getEvents() {
        return this.events;
    }
    subscribEvent(key) {
        let obs = new EventEmitter();
        this.events.subscribe((resp) => {
            if (resp.key == key) {
                obs.emit(resp.data);
            }
        });
        return obs;
    }
    emitEvent(key, data = null) {
        let event = { key: key, data: data };
        console.info("Event " + key + "emit", event);
        return this.events.emit(event);
    }
}
BaseCustomService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: BaseCustomService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
BaseCustomService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: BaseCustomService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: BaseCustomService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class BaseModel {
    constructor() {
        this.localStored = null;
    }
    isLocalStored() {
        return this.localStored ? true : false;
    }
    setLocalStored(local = true) {
        this.localStored = local;
        return this;
    }
    initialize(data) {
        //        console.log("Parsing class", this);
        let key;
        for (key in data) {
            //            console.log(key, this.hasOwnProperty(key) && typeof this[key] !== 'function');
            if (this.hasOwnProperty(key) && typeof this[key] !== 'function') {
                this[key] = data[key];
            }
        }
        return this;
    }
    serialize() {
        var toRet = [];
        let key;
        for (key in this) {
            if (typeof this[key] !== 'function') {
                toRet[key] = this[key];
            }
        }
        return toRet;
    }
    toString() {
        var toRet = '';
        let key;
        for (key in this) {
            if (typeof this[key] !== 'function') {
                toRet += key + " => " + this[key] + "\n";
            }
        }
        return toRet;
    }
    clear() {
        for (let key in this) {
            //set all properties to null
            if (this.hasOwnProperty(key) && typeof this[key] !== 'function') {
                if (key != 'http' && key != 'api' && key != 'helper') {
                    //                    console.log("removing ", key, typeof this[key]);
                    this[key] = null;
                }
            }
        }
    }
    clone() {
        return JSON.parse(JSON.stringify(this));
    }
}

class AuthModel extends BaseModel {
    constructor() {
        super();
        this.access_token = null;
        this.refresh_token = null;
        this.expires_in = null;
        this.currentDate = null;
        this.setCurrentDate();
    }
    getAccess_token() {
        return this.access_token;
    }
    setAccess_token(access_token) {
        this.access_token = access_token;
        return this;
    }
    getRefresh_token() {
        return this.refresh_token;
    }
    setRefresh_token(refresh_token) {
        this.refresh_token = refresh_token;
        return this;
    }
    getExpires_in() {
        return this.expires_in;
    }
    setExpires_in(expiresIn) {
        this.expires_in = expiresIn;
        return this;
    }
    getCurrentDate() {
        return this.currentDate;
    }
    setCurrentDate(seconds = null) {
        //if seconds is null, get actual timestamp
        if (!seconds) {
            seconds = new Date().getTime();
        }
        this.currentDate = seconds;
        return this;
    }
    tokenExpired() {
        //temporal
        var expired = true;
        if (this.getExpires_in() && this.getCurrentDate()) {
            var currentTime = new Date().getTime();
            //            console.log("Auth date", new Date(this.getCurrentDate()));
            //            console.log("Expire date", new Date((this.getExpires_in() * 1000) + this.getCurrentDate()));
            //            console.log("Now date", new Date(currentTime));
            //multiplicate by 1000 to get milisecons
            if (+((this.getExpires_in() * 1000) + this.getCurrentDate()) > currentTime) {
                expired = false;
            }
        }
        return expired;
    }
}

const default_login_path = "api/login";
const default_logout_path = "api/logout";
class AuthService extends BaseCustomService {
    constructor(api_provider, config) {
        super();
        this.api_provider = api_provider;
        this.config = config;
        this._config = this.config;
    }
    logout(url_custom) {
        this._config.default_routes ? this._url = default_logout_path : this._url = url_custom;
        return new Promise((resolve, reject) => {
            this.api_provider.post(this._url).subscribe((resp) => {
                this.clearLocal();
                //                            this.events.publish(USER_EVENT_CHANGE);
                resolve(resp);
            }, (err) => {
                this.clearLocal();
                //                    this.events.publish(USER_EVENT_CHANGE);
                reject(err);
            });
        });
    }
    login(username, password, authConfig) {
        let body;
        if (this._config.oauthMode) {
            body = {
                "username": username,
                "password": password,
                "grant_type": this._config.grant_type,
                "client_id": this._config.client_id,
                "client_secret": this._config.client_secret
            };
        }
        else {
            body = {
                "username": username,
                "password": password
            };
        }
        authConfig.customBody ? body = authConfig.body : body;
        this._config.default_routes ? this._url = default_login_path : this._url = authConfig.endpoint;
        return new Promise((resolve, reject) => {
            if (authConfig.options) {
                this.api_provider.form(this._url, body).subscribe((resp) => {
                    let auth = new AuthModel();
                    auth.initialize(resp);
                    this.setLocalAuth(auth);
                    authConfig.customModel ? resolve(resp) : resolve(auth);
                }, (err) => {
                    reject(err);
                });
            }
            else {
                this.api_provider.post(this._url, body).subscribe((resp) => {
                    let auth = new AuthModel();
                    auth.initialize(resp);
                    this.setLocalAuth(auth);
                    authConfig.customModel ? resolve(resp) : resolve(auth);
                }, (err) => {
                    reject(err);
                });
            }
        });
    }
    storeLogin(username, password) {
        this.setLocal(STORAGE_KEY_LOGIN, {
            'username': username,
            'password': password,
        });
        //            this.events.publish(STORAGE_KEY_LOGIN);
    }
    getLogin() {
        return this.getLocal(STORAGE_KEY_LOGIN);
    }
    getLocalAuth() {
        let auth = this.getLocal(STORAGE_KEY_AUTH);
        let obj = new AuthModel();
        obj.initialize(auth);
        return obj;
    }
    setLocalAuth(auth) {
        this.setLocal(STORAGE_KEY_AUTH, auth);
        return this;
    }
    isGranted() {
        let auth = this.getLocalAuth();
        if (auth) {
            if (auth.getAccess_token() && !auth.tokenExpired()) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    }
}
AuthService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: AuthService, deps: [{ token: ApiProvider }, { token: LibConfiguration }], target: i0.ɵɵFactoryTarget.Injectable });
AuthService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: AuthService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.5", ngImport: i0, type: AuthService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: ApiProvider }, { type: LibConfiguration }]; } });

;

/*
 * Public API Surface of angular-auth
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AngularAuthModule, ApiModule, ApiProvider, AuthModel, AuthService, EVENT_KEY_USER, LibConfiguration, STORAGE_KEY_AUTH, STORAGE_KEY_LOGIN, STORAGE_KEY_USER, USER_EVENT_CHANGE };
